import type { ComponentType } from 'react'
import {
  type IconProps,
  LogoEhInlineColor,
  mediaQueryHookQueries,
  RouterLink,
  useMediaQuery,
} from '@/components'
import HeaderCenteredContent from './components/HeaderCenteredContent'
import HeaderSplitContent from './components/HeaderSplitContent'
import testLabels from './Header.labels'
import * as styles from './Header.styles'

interface HeaderWithBackButton {
  backButtonLink?: string
  closeButtonLink?: never
}

interface HeaderWithCloseButton {
  backButtonLink?: never
  closeButtonLink?: string
}

interface HeaderLogoProps {
  logo?: ComponentType<IconProps>
}

const HeaderLogo = ({ logo }: HeaderLogoProps) => {
  const isXs = useMediaQuery(mediaQueryHookQueries.xs)
  const logoSize = isXs ? 28 : 36
  const defaultLogo = LogoEhInlineColor
  const ResolvedLogo = logo ?? defaultLogo

  return <ResolvedLogo height={logoSize} />
}

export type HeaderProps = {
  transparent?: boolean
  logoRoute?: string | null
  logo?: ComponentType<IconProps>
} & (HeaderWithBackButton | HeaderWithCloseButton)

const Header = ({ logo, logoRoute, transparent }: HeaderProps) => {
  const isXs = useMediaQuery(mediaQueryHookQueries.xs)
  const isMd = useMediaQuery(mediaQueryHookQueries.md)
  const isLg = useMediaQuery(mediaQueryHookQueries.lg)

  const getContent = () => {
    const commonProps = {
      logo:
        logoRoute === null ? (
          <HeaderLogo logo={logo} />
        ) : (
          <RouterLink
            data-label={testLabels.commonLayoutHeaderDeeplinkLogoLink}
            to={logoRoute ?? myESET.envData.HomePortalUrl}
          >
            <HeaderLogo logo={logo} />
          </RouterLink>
        ),
    }

    if (isLg) return <HeaderSplitContent {...commonProps} />

    return <HeaderCenteredContent {...commonProps} />
  }

  return (
    <header css={[styles.header(isMd), styles.headerBackground(transparent)]}>
      <div css={[styles.headerContent(isXs)]}>{getContent()}</div>
    </header>
  )
}

export default Header
